module.exports = __webpack_public_path__ + "static/media/26UNRWA12.510b3297.jpg";